import React from 'react';
import { Calendar, CreditCard, Ticket } from 'lucide-react';
import { Link } from 'react-router-dom';

interface SubscriptionPromptProps {
  calendarName: string;
  calendarId: string;
  paymentType?: 'free' | 'subscription' | 'one_time';
  price?: number | null;
}

export default function SubscriptionPrompt({ 
  calendarName, 
  calendarId,
  paymentType = 'free',
  price = null
}: SubscriptionPromptProps) {
  const returnTo = encodeURIComponent(window.location.pathname);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 text-center">
      <div className="flex justify-center mb-4">
        {paymentType === 'subscription' ? (
          <CreditCard className="h-12 w-12 text-purple-600" />
        ) : paymentType === 'one_time' ? (
          <Ticket className="h-12 w-12 text-purple-600" />
        ) : (
          <Calendar className="h-12 w-12 text-purple-600" />
        )}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {paymentType === 'subscription' ? (
          `Subscribe to ${calendarName}`
        ) : paymentType === 'one_time' ? (
          `Purchase tickets for ${calendarName}`
        ) : (
          `Subscribe to ${calendarName}`
        )}
      </h3>
      <p className="text-gray-600 mb-6">
        {paymentType === 'subscription' ? (
          `Sign in to subscribe for $${(price || 0) / 100}/month`
        ) : paymentType === 'one_time' ? (
          `Sign in to purchase tickets for $${(price || 0) / 100} each`
        ) : (
          'Sign in to subscribe and stay updated with events'
        )}
      </p>
      <Link
        to={`/login?returnTo=${returnTo}&calendarId=${calendarId}`}
        className="w-full px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 inline-block"
      >
        Sign in to {paymentType === 'one_time' ? 'Purchase' : 'Subscribe'}
      </Link>
    </div>
  );
}